'use client';

import React, { FC } from 'react';
import Link from 'next/link';
import Avatar from '@/components/Avatar';
import usersDb, { TUser } from '@/mocks/db/users.db';
import classNames from 'classnames';

interface IRoomEntryProps {
  roomId: string;
  name: string;
  avatarUrl: string;
  selected?: boolean;
  lastMessage?: string;
}

const RoomEntry: FC<IRoomEntryProps> = (props) => {
  const {
    roomId,
    name,
    avatarUrl,
    selected = false,
    lastMessage = "last message from the room"
  } = props;

  // Step 1: Generate a random index
  // const randomIndex = Math.floor(Math.random() * usersDb.length);

  // Step 2: Select a user using the random index
  // const randomUser: TUser = usersDb[randomIndex];

  return (
    <Link 
      href={`/chats/${roomId}`}
    >
      <div className={classNames(
        'flex items-center py-4 px-4',
        { 'bg-zinc-200 rounded-lg': selected },
      )}>
        <Avatar
          src={avatarUrl}
          className='!w-14'
          width={56}
          height={56}
        />
        <div className='ml-4'>
          <div className='font-bold'>{name}</div>
          <div>{lastMessage}</div>
        </div>
      </div>
    </Link>
  )
}

export default RoomEntry;